
export default {
    props: {
        dataset: Array,
        text: String,
    },
    data() {
        return {
            sortedDataset: this.dataset.sort((a, b) => b.percentage - a.percentage)
        };
    },
}
